let calendlyLoadPromise = null;

export function loadCalendly() {
  if (typeof window !== "undefined" && window.Calendly) {
    return Promise.resolve(window.Calendly);
  }

  if (!calendlyLoadPromise) {
    calendlyLoadPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      script.onload = () => resolve(window.Calendly);
      script.onerror = () => reject(new Error("Failed to load Calendly"));
      document.head.appendChild(script);
    });
  }

  return calendlyLoadPromise;
}
